import { useState } from "react";
import { useFormContext } from "react-hook-form";
import { DropzoneType, IFile, ImageDropzone } from "./ImageDropzone";
import { InputLabel } from "../InputLabel/InputLabel";
import { InputErrorMessage } from "../InputErrorMessage/InputErrorMessage";

export const PaziaFileDropzone = ({
  name,
  required,
  label,
  single,
  type,
  onDrop,
  preview,
  onFileToLarge,
  isClearable = !required,
  className = "",
}: PaziaFileDropzoneProps) => {
  const { setValue, getValues } = useFormContext();
  const values = getValues(name);
  // ImageDropzone keeps its own preview state, so remount it to drop the preview on "Wyczyść"
  const [clearCount, setClearCount] = useState(0);

  return (
    <div className={`pazia-file-dropzone-${name} ${className}`}>
      <InputLabel name={name} label={label} required={required} />
      <ImageDropzone
        key={clearCount}
        onDrop={(x) => {
          const value = single ? x[0] : x;
          if (!value) return;
          setValue(name, value, { shouldDirty: true });
          //@ts-ignore
          if (onDrop && value) onDrop(value);
        }}
        defaultValues={values}
        type={type}
        preview={preview}
        onFileToLarge={onFileToLarge}
      />
      {isClearable && (
        <div
          className="text-xs font-semibold text-right mt-1 cursor-pointer"
          onClick={() => {
            setValue(name, undefined, { shouldDirty: true });
            setClearCount((x) => x + 1);
          }}
        >
          Wyczyść
        </div>
      )}
      <InputErrorMessage name={name} />
    </div>
  );
};

interface PaziaFileDropzoneProps {
  name: string;
  required?: boolean;
  label?: string;
  className?: string;
  type: DropzoneType | DropzoneType[];
  multiple?: boolean;
  single?: boolean;
  preview?: "image" | "file";
  onDrop?: ((file: IFile[]) => void) | ((file: IFile) => void);
  onFileToLarge?: () => void;
  isClearable?: boolean;
}
